import React from 'react';
import { FaCrown, FaGamepad, FaBolt, FaAd } from 'react-icons/fa';
import './ProUpgradeCard.css';

/**
 * Shown in place of Pro-only features (Game of Life, interactive lessons)
 * for users on the free tier.
 */
const ProUpgradeCard = ({ feature = 'This feature' }) => (
  <div className="pro-upgrade-card">
    <div className="pro-upgrade-icon">
      <FaCrown />
    </div>
    <h2>{feature} is a Pro feature</h2>
    <p>
      Upgrade to <strong>InvestNYou Pro</strong> to unlock everything:
    </p>
    <ul className="pro-upgrade-perks">
      <li><FaGamepad /> Game of Life simulator</li>
      <li><FaBolt /> Interactive interactive workshops</li>
      <li><FaAd /> Ad-free experience</li>
    </ul>
    <button className="pro-upgrade-btn" disabled title="Coming soon">
      <FaCrown /> Upgrade to Pro — coming soon
    </button>
    <p className="pro-upgrade-note">
      Pro plans arrive with our alpha launch. Everything you've unlocked stays yours.
    </p>
  </div>
);

export default ProUpgradeCard;
